import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { FormField, Input } from '@legalshield/adonis-ux-framework';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
};

const PhoneField = <T extends FieldValues>({ control, name, label, required }: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <FormField
        id={String(name)}
        label={label}
        required={required}
        status={fieldState.error ? 'invalid' : undefined}
        validationHint={fieldState.error?.message}
      >
        <NumberFormat
          customInput={Input as any}
          format="(###) ###-####"
          mask="_"
          type="tel"
          placeholder={label}
          value={(field.value as string | undefined) ?? ''}
          onValueChange={(values) => field.onChange(values.value)}
          onBlur={field.onBlur}
          {...(fieldState.error ? { status: 'invalid' } : {})}
        />
      </FormField>
    )}
  />
);

export default PhoneField;
